/** @file Checks the rig's `format` tag and major version before anything else is read. */
import type { Pose2DJson } from '@pose2d/format/types';
import { coreFail } from '../coreFail';

/** Major version of `pose2d.rig` this core reads (= FORMAT_VERSION.rigMajor; format is a type-only import here). */
const RIG_MAJOR = 1;

/** Throws VALIDATION unless json is an object tagged `pose2d.rig` whose `version` is `1.<minor>`. */
export function checkRigHeader(json: Pose2DJson): void {
  const raw: unknown = json;
  if (typeof raw !== 'object' || raw === null) coreFail('VALIDATION', 'rig JSON must be an object');
  const { format, version } = raw as { format?: unknown; version?: unknown };
  if (format !== 'pose2d.rig') coreFail('VALIDATION', 'expected format "pose2d.rig"', { path: 'format' });
  const text = typeof version === 'string' ? version : typeof version;
  const major = /^(\d+)\.\d+$/.exec(text)?.[1];
  if (major === undefined || Number(major) !== RIG_MAJOR) {
    coreFail('VALIDATION', `rig version ${text} is not supported; this runtime reads ${String(RIG_MAJOR)}.x`, {
      path: 'version',
      hint: 'export the rig again with a matching Pose2D version, or update the runtime',
    });
  }
}
